/**
 * Formats an error into a consistent error message string
 */
export function formatErrorMessage(error: unknown): string {
    if (error instanceof Error) {
        return error.message
    }

    if (typeof error === "object" && error !== null) {
        // Handle API error objects
        const apiError = error as { detail?: string }
        if (apiError.detail) {
            return apiError.detail
        }

        try {
            return JSON.stringify(error)
        } catch {
            return "Unknown error object"
        }
    }

    return String(error || "Unknown error")
}

/**
 * Safely extracts error details from API responses
 */
export function extractApiErrorMessage(error: any): string {
    if (!error) return "An error occurred"

    if (typeof error === "string") return error

    if (error.detail) return error.detail

    try {
        return JSON.stringify(error)
    } catch {
        return "Error processing API response"
    }
}
